import React from 'react';

import ProjectDetail from './ProjectDetail';

const ProjectDetailWrapper: React.FC = () => {
    return <ProjectDetail />;
};

export default ProjectDetailWrapper;
